import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MainTitle from 'base/components/MainTitle/index';
import { updateMailingList } from 'documents/store/mailinglists/actions';
import { getActiveMailingList } from 'documents/store/mailinglists/selectors';
import { closeModal } from 'modal/store/actions';
import MailingListForm from './MailingListForm';


const UpdateSpaceModal = ({
  name, mailingList, updateMailingList, closeModal,
}) => (
  <>
    <MainTitle withSpaceBelow>Edit mailing list</MainTitle>

    <MailingListForm
      mailingList={mailingList}
      onSubmit={(mailingList) => {
        updateMailingList(mailingList);
        closeModal(name);
      }}
    />
  </>
);
UpdateSpaceModal.propTypes = {
  name: PropTypes.string.isRequired,
  mailingList: PropTypes.object.isRequired, // eslint-disable-line
  updateMailingList: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  mailingList: getActiveMailingList(state),
});


const mapDispatchToProps = {
  updateMailingList,
  closeModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdateSpaceModal);
